import { h, render } from 'preact';
import ResultsApp from './components/ResultsApp';
import AdLoader from './utils/ad-loader';

const PRIMARY_GUTEN_TAG = 'subject-2018-elections';

const url =
  'https://s3.amazonaws.com/sos-test.texastribune.org/results/2018-primary.json';
const app = document.getElementById('app');

render(<ResultsApp url={url} />, app);

import(/* webpackChunkName: "analytics" */ '@data-visuals/analytics').then(
  analytics => analytics.init()
);

const loader = new AdLoader({
  targetingKey: 'guten',
  targetingValue: PRIMARY_GUTEN_TAG,
});

loader.init();



// WEBPACK FOOTER //
// ./main.js